<template>
    <apexchart type="bar" height="350" :options="chartOptions" :series="chartData"></apexchart>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {

    name: "RadarChart",
    components: {
        apexchart: VueApexCharts,
    },
    props:{
        chartData:{
            type:Array
        }
    },
    data() {
        return {
            series: this.chartData,
        };
    },
    computed: {
        chartOptions() {
            return {
                chart: {
                    type: 'bar',
                    height: 350,
                    defaultLocale: 'pl',
                    locales: [{
                        name: 'pl',
                        options: {
                            toolbar: {
                                exportToSVG:$.i18n._('chart_export_SVG'),
                                exportToPNG:$.i18n._('chart_export_PNG') ,
                                exportToCSV:$.i18n._('chart_export_CSV'),
                                zoomIn:$.i18n._('chart_zoom_in'),
                                zoomOut:$.i18n._('chart_zoom_out'),
                                pan:$.i18n._('chart_pan'),
                                reset:$.i18n._('chart_reset'),
                            }
                        }
                    }],
                },
                states: {
                    hover: {
                        filter: {
                            type: 'none' // Wyłącza przezroczystość na hover
                        }
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded'
                    },
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: this.chartData[0].x_axis, // lub inna odpowiednia właściwość w chartData
                },
                yaxis: {
                    title: {
                        text: '$ (thousands)'
                    }
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return "$ " + val + " thousands"
                        }
                    }
                }
            };
        },
    },
}
</script>

<style scoped>

</style>
